<template>
  <div class="inventory-stats-container">
    <div class="inventory-stats-flow">
      <section class="col-span-2">
        <div class="flex gap-2 items-center">
          <img src="../../assets/inventory.svg" class="w-4" />
          <h4>Inventory</h4>
        </div>
        <div class="inventory-stat-items">
          <div class="inventory-stat-item">
            <h6>Items in warehouse</h6>
            <p>
              {{ team.inventoryCount | formatNumber }}
            </p>
          </div>
          <div class="inventory-stat-item">
            <h6>Remaining items</h6>
            <p>
              {{ team.remainingSubscriptionInventory | formatNumber }}
            </p>
          </div>
        </div>
      </section>
      <div class="inventory-stat-chart relative z-50">
        <div class="chart" v-if="loadGloabalDashboard">
          <PieChart
            :styles="myStyles"
            :height="350"
            :chartdata="teamInventoryData"
          />
          <div class="donut-inner">
            <h5>{{ remainingShipmantsPercentage }}%</h5>
            <span>remaining</span>
          </div>
        </div>
      </div>
      <div
        class="inventory-stat-action col-span-2 flex items-start justify-end"
      >
        <button
          v-if="isTeamOwner"
          @click="handleManageInventory"
          class="whitebutton-gemnote button-gemnote-glass--tiny gray"
        >
          <span>Manage</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus } from '../../helpers'
export default {
  name: 'InventoryStats',
  components: {
    PieChart: () => import('@/components/ReportHelpers/PieChart')
  },
  created() {
    this.$store.dispatch('report/avarageShipments')
  },
  computed: {
    myStyles() {
      return {
        width: '130px'
      }
    },
    loadGloabalDashboard() {
      return progressStatus(this.loadBarChart)
    },
    isTeamOwner() {
      return this.$store.getters['profile/isTeamOwner']
    },
    remainingShipmantsPercentage() {
      return Math.round(
        (Number(this.team.remainingSubscriptionInventory) /
          (Number(this.team.remainingSubscriptionInventory) +
            Number(this.team.inventoryCount))) *
          100
      )
    },

    formatAverageShipments() {
      return this.averageShipments.toLocaleString('en-US')
    },
    ...mapState({
      loadBarChart: state => state.report.loadBarChart,
      averageShipments: state => state.report.averageShipments,
      remainingShipments: state => state.report.remainingShipments,
      teamInventoryData: state => state.team.teamInventoryData,
      team: state => state.team.team
    })
  },
  methods: {
    handleManageInventory() {
      this.$router.push('/manage-inventory')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.whitebutton-gemnote--small {
  font-size: 0.813rem;
  font-weight: normal;
  height: 2.5rem;
  width: max-content !important;
  padding: 0 0rem !important;
}

.button-gemnote-glass--tiny {
  width: max-content !important;
  font-weight: 400 !important;
  padding: 0 1rem !important;
}

.inventory-stats-container {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid $main-6;
  border-radius: 2px;

  .inventory-stats-flow {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }
  .inventory-stat-items {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    .inventory-stat-item {
      text-align: left;
      h6 {
        font-size: 0.813rem;
      }
      p {
        font-size: 1.75rem;
        margin-top: 0.2rem;
      }
    }
  }
}

h4 {
  font-family: $editorial;
  font-weight: normal;
}

.chart {
  position: relative;
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  .donut-inner {
    position: absolute;
    left: 0%;
    width: 100%;
    text-align: center;

    h5 {
      font-family: $inter;
      font-weight: bold;
      font-size: 0.913rem;
      position: relative;
      top: 5px;
    }

    span {
      position: relative;
      font-size: 0.68rem;
      font-family: $inter;
      font-weight: 600;
      top: -4px;
    }
  }
}

@media (max-width: 826px) {
  .chart {
    width: 100%;
  }
}

@media (max-width: 748px) {
  .inventory-stats-container {
    .inventory-stat-chart {
      grid-column-start: span 2;
      width: max-content;
      margin: 0px auto;
    }
    .inventory-stat-action {
      grid-column-start: span 1;
    }
    .inventory-stats-flow {
      gap: 1rem 0px;
    }
  }
}
@media (max-width: 490px) {
  .inventory-stats-container {
    .order-stat-items {
      gap: 2rem;
    }
    .inventory-stats-flow {
      grid-template-columns: repeat(1, 1fr);
    }
    .inventory-stat-action {
      align-items: center;
      justify-content: center;
    }
  }
}
@media (max-width: 998px) {
  .inventory-stats-container {
    .inventory-stat-chart {
      .inventory-stat-chart-inner {
        left: 13%;

        .count {
          font-weight: bold;
          font-size: 0.913rem;
        }
        .title {
          position: relative;
          top: -5px;
          font-weight: 500;
          font-size: 0.68rem;
        }
      }
    }
  }
}
</style>
